'use client';

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import UPIPayment from "./payment-component/upi";
import CardPayment from "./payment-component/card-payment";



const PaymentTypes = () => {

    const paymentTypeTitle = [
        { id: 'upi', value: 'item-1', title: 'UPI', file: <UPIPayment /> },
        { id: 'card', value: 'item-2', title: 'Credit/Debit Card', file: <CardPayment /> },
        { id: 'banking', value: 'item-3', title: 'Net Banking', file: <CardPayment /> },
        { id: 'wallet', value: 'item-4', title: 'Wallet', file: <CardPayment /> },
        { id: 'emi', value: 'item-5', title: 'Easy EMI', file: <CardPayment /> }
    ]

    return (
        <div>
            {paymentTypeTitle.map((data: any, index: number) =>
                <Accordion key={data.id} type="single" collapsible className="w-full mt-5 mb-8 border-0">
                    <AccordionItem value={data.value}>
                        <AccordionTrigger>

                            <h4 className="font-semibold hover:no-underline">{data.title}</h4>

                        </AccordionTrigger>
                        <AccordionContent>
                            <div className="p-5">
                                {data.file}
                            </div>
                        </AccordionContent>

                    </AccordionItem>
                </Accordion>
            )}
        </div>
    )
}

export default PaymentTypes;